export const notFound = { de: 'Page not found', en: 'Page not found', sv: 'Sidan hittades inte' };
export const goHome = { de: 'Go to home page', en: 'Go to home page', sv: 'Gå till förstasidan' };
